module.exports = __webpack_public_path__ + "img/empty.3ca114f5.svg";